export default "__VITE_ASSET__DUOq9A6y__"